export var radius = 100 / (2 * Math.PI);
export var width = 42;
export var center = {
  x: width / 2,
  y: width / 2
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-donut-chart/es/constants.js
// module id = 2394
// module chunks = 25